import { useDispatch, useSelector } from "react-redux";
import { currentSharedMailBoxSelector } from "../selectors";
import { sendMessageToParentWindow } from "../helpers";
import { toggleSMAdvancedSetting } from "../../sharedmailbox/settings/actions";



export const useSmSettings = () => {
    const smData = useSelector(currentSharedMailBoxSelector);
    const dispatch = useDispatch();

    const toggleSetting = (id, value) => {
        return dispatch(toggleSMAdvancedSetting(smData, id, value)).then(() => {
            sendMessageToParentWindow('refetch-account-refresh',{ refetchReactAccountRefreshData: true});
        })
    }
    return {
        toggleSetting,
        settings: smData?.sm_adv_settings ?? []
    }
}